module.exports = "/_next/static/images/d1b6a16be0f175fa9bb93a5f63d2262d-roxinho-card-with-phone-md@1x.jpg";